export enum ReviewSource {
  FUNNOW = 0,
  EATIGO = 1,
  NICEDAY = 2,
}
